import { useQuery } from "@tanstack/react-query";
import type { DelayCategory } from "../../categories/models/CatalogCategory";
import { getCatalogCategories } from "../../categories/repositories/CatalogCategoriesRepository";

export const useDelayCategoriesQuery = (
  assetId: number,
  includeInactives: boolean,
  onError?: (error: Error) => void,
) => {
  return useQuery({
    queryKey: ["delay-categories", assetId, includeInactives],
    queryFn: async ({ signal }) => {
      const resp = await getCatalogCategories({
        includeInactives,
        delayAreaAssetId: assetId,
        includeAncestor: assetId !== 0,
        signal,
      });
      if (resp.ok) {
        return (resp.data?.tables?.[0]?.rows ?? []) as DelayCategory[];
      }
      throw new Error(resp.message);
    },
    onError,
  });
};
